import axios from 'axios'

export const uploadChunkedFile = async (
  url: string,
  file: File,
  options?: {
    onUploadProgress: (progress: number) => void
    signal?: AbortSignal
  },
) => {
  const CHUNK_SIZE = 1024 * 1024 * 10 // 10 mb
  const fileSize = file.size
  const totalChunks = Math.ceil(fileSize / CHUNK_SIZE)
  let currentChunkCounter = 0

  const { status, headers } = await _checkUploadStatus(
    url,
    fileSize,
    options?.signal,
  )

  const range = headers.range

  if (range && status === 308) {
    const [, totalOfBytesLoadedAux] = range.split('-')
    const totalOfBytesLoaded = Number(totalOfBytesLoadedAux)

    currentChunkCounter = Math.floor(totalOfBytesLoaded / CHUNK_SIZE)
    options?.onUploadProgress((currentChunkCounter * 100) / totalChunks)
  } else if (status === 200) {
    options?.onUploadProgress(100)
    return
  }

  while (currentChunkCounter < totalChunks) {
    const start = currentChunkCounter * CHUNK_SIZE
    const end = Math.min(start + CHUNK_SIZE, fileSize)

    const chunk = file.slice(start, end)

    const { status } = await _uploadChunk(
      url,
      chunk,
      { start, end, fileSize },
      options?.signal,
    )

    if (status !== 308) {
      options?.onUploadProgress(100)
      break
    }

    currentChunkCounter++
    options?.onUploadProgress((currentChunkCounter * 100) / totalChunks)
  }
}

const _validadeStatus = (status: number) => [200, 201, 308].includes(status)

const _checkUploadStatus = async (
  url: string,
  fileSize: number,
  signal?: AbortSignal,
) =>
  axios.put(url, undefined, {
    headers: {
      'Content-Range': `bytes */${fileSize}`,
      'Content-Type': 'application/json',
    },
    signal,
    validateStatus: _validadeStatus,
  })

const _uploadChunk = async (
  url: string,
  chunk: Blob,
  { start, end, fileSize }: { start: number; end: number; fileSize: number },
  signal?: AbortSignal,
) =>
  axios.put(url, chunk, {
    headers: {
      'Content-Range': `bytes ${start}-${end - 1}/${fileSize}`,
    },
    signal,
    validateStatus: _validadeStatus,
  })
